<pmv-main-content>
    <pmv-main-content-header title="Desistir de Convocação" [subtitle]="subtitle">
        <pmv-loading [isLoading]="loading"></pmv-loading>
    </pmv-main-content-header>
</pmv-main-content>

<pmv-main-content-body>

    <div class="container">
        <div class="row" style="margin-bottom: 25px;;">
            <div class="col-xs-12">
                <h2>Informações do Edital/Convocação</h2>
                <span style="display: block;color:#2D699F;">{{editalAnoPss}}</span><br>
                <span>Outras informações relevantes</span>
            </div>
        </div>

            <form #form="ngForm" validateOnSubmit (submit)="onSubmit(form)">
              <div class="row">

                <span> Texto de declaração de desistencia de convocação.</span>

                <pmv-fieldset header="Validar informações" class="filtros-fieldset">
                  <div class="form-group row">
                    <div class="col-md-6 col-xs-12">
                      <pmv-checkbox name="confirmarVerdadeInfoValue" [(ngModel)]="confirmarVerdadeInfo"
                                    [options]="confirmarVerdadeiraOptions" optionLabelField="label" optionValueField="value">
                      </pmv-checkbox>
                    </div>
                  </div>
                </pmv-fieldset>


                <div class="col-md-12" style="text-align: right; padding: 5px 22px;">
                  <button type="submit" class="btn btn-primary">Salvar</button>
                  <button type="button" class="btn btn-warning" (click)="voltar()">Cancelar</button>
                </div>
              </div>
            </form>
       
    </div>

</pmv-main-content-body>



// WEBPACK FOOTER //
// ./src/app/pages/candidato-convocado/desistir/desistir-convocacao.component.html